import { EnhancedOrderUploadRow } from '../../components/Upload/EnhancedUpload/types'
import {
  DropdownState,
  ErrorInfo,
  OrderRowInfo,
  WatchlistInfo,
  WorkingWatchlistUpload
} from './types'
import { Book } from '../books/types'
import { Filter } from '../filter/types'
import { StagedOrder } from '../stagedOrders/types'
import { WatchlistDetails } from '../watchList/types'

export const uploadOrdersFailure = (errors: ErrorInfo[]) =>
  ({
    type: 'upload.uploadOrdersFailure',
    payload: errors,
    error: true
  } as const)
export type UploadOrdersFailure = ReturnType<typeof uploadOrdersFailure>

export const uploadOrdersServerError = (message: string) =>
  ({ type: 'upload.uploadOrdersServerError', payload: message } as const)
export type UploadOrdersServerError = ReturnType<typeof uploadOrdersServerError>

export const resetInvalidIdentifiers = () =>
  ({ type: 'upload.resetInvalidIdentifiers' } as const)
export type ResetInvalidIdentifiers = ReturnType<typeof resetInvalidIdentifiers>

export const resetUploadOrdersServerError = () =>
  ({ type: 'upload.resetUploadOrdersServerError' } as const)
export type ResetUploadOrdersServerError = ReturnType<
  typeof resetUploadOrdersServerError
>

export const createNewWatchlistWithSecurityIds = (
  gridIndex: number,
  name: string,
  permission: 0 | 1,
  book: Book,
  orders: OrderRowInfo[],
  securityIds: number[][],
  identifiers: string[],
  filter: Filter,
  myFirmChecked: boolean,
  size: number,
  useAdvancedFilter: boolean
) =>
  ({
    type: 'upload.createNewWatchlistWithSecurityIds',
    payload: {
      gridIndex,
      name,
      permission,
      book,
      orders,
      securityIds,
      identifiers,
      filter,
      myFirmChecked,
      size,
      useAdvancedFilter
    }
  } as const)
export type CreateNewWatchlistWithSecurityIdsAction = ReturnType<
  typeof createNewWatchlistWithSecurityIds
>

export const createWatchlistWithEnhancedUploadRows = (
  watchlist: WorkingWatchlistUpload,
  gridIndex: number,
  book?: Book
) =>
  ({
    type: 'upload.createWatchlistWithEnhancedUploadRows',
    payload: { watchlist, gridIndex, book }
  } as const)
export type CreateWatchlistWithEnhancedUploadRowsAction = ReturnType<
  typeof createWatchlistWithEnhancedUploadRows
>

export const createWatchlistFromWatchlistInfo = (
  watchlist: WatchlistInfo,
  identifiers: string[],
  userId = 0
) =>
  ({
    type: 'upload.createWatchlistFromWatchlistInfo',
    payload: { watchlist, identifiers, userId }
  } as const)
export type CreateWatchlistFromWatchlistInfoAction = ReturnType<
  typeof createWatchlistFromWatchlistInfo
>

export const uploadEnhancedOrderRows = (
  gridIndex: number,
  watchlist: WatchlistDetails,
  rows: EnhancedOrderUploadRow[],
  bookId: number
) =>
  ({
    type: 'upload.uploadEnhancedOrderRows',
    payload: { gridIndex, watchlist, rows, bookId }
  } as const)
export type UploadEnhancedOrderRowsAction = ReturnType<
  typeof uploadEnhancedOrderRows
>

export const uploadOrdersFromPreviousDate = (stagedOrders: StagedOrder[]) =>
  ({
    type: 'upload.uploadOrdersFromPreviousDate',
    payload: stagedOrders
  } as const)
export type UploadOrdersFromPreviousDate = ReturnType<
  typeof uploadOrdersFromPreviousDate
>

export const setNewWatchlistTransactionId = (
  gridIndex: number,
  transactionId: number
) =>
  ({
    type: 'upload.setNewWatchlistTransactionId',
    payload: { gridIndex, transactionId }
  } as const)
export type SetNewWatchlistTransactionIdAction = ReturnType<
  typeof setNewWatchlistTransactionId
>

export const resetNewWatchlistTransactionId = (gridIndex: number) =>
  ({
    type: 'upload.resetNewWatchlistTransactionId',
    payload: { gridIndex }
  } as const)
export type ResetNewWatchlistTransactionId = ReturnType<
  typeof resetNewWatchlistTransactionId
>

export const toggleDropdownState = (gridIndex: number, state: DropdownState) =>
  ({
    type: 'upload.toggleDropdownState',
    payload: { gridIndex, state }
  } as const)
export type ToggleDropdownState = ReturnType<typeof toggleDropdownState>

export const fetchSymbolDetails = (symbols: string[]) =>
  ({ type: 'upload.fetchSymbolDetails', payload: symbols } as const)
export type FetchSymbolDetailsAction = ReturnType<typeof fetchSymbolDetails>

export const logInvalidIdentifiers = (identifiers: string[]) =>
  ({ type: 'upload.logInvalidIdentifiers', payload: { identifiers } } as const)
export type LogInvalidIdentifiersAction = ReturnType<
  typeof logInvalidIdentifiers
>

export type UploadOrdersActions =
  | UploadOrdersFailure
  | UploadOrdersServerError
  | ResetInvalidIdentifiers
  | ResetUploadOrdersServerError
  | UploadOrdersFromPreviousDate
  | SetNewWatchlistTransactionIdAction
  | ResetNewWatchlistTransactionId
  | CreateNewWatchlistWithSecurityIdsAction
  | ToggleDropdownState
  | CreateWatchlistWithEnhancedUploadRowsAction
  | UploadEnhancedOrderRowsAction
  | FetchSymbolDetailsAction
  | LogInvalidIdentifiersAction
